import { QueryClient } from '@tanstack/react-query';
import { ListSystemsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { LoaderFunctionArgs } from 'react-router';
import { listSystemsQuery } from '~/shared/api/system.queries';
import { checkAuthorization, getAuthUser } from '~/shared/auth/auth-utils';

export type SystemPageLoaderResult = {
  systems?: ListSystemsResponse;
};
export const systemLayoutPageLoader =
  (queryClient: QueryClient) =>
  async ({
    request,
  }: LoaderFunctionArgs): Promise<SystemPageLoaderResult | Response> => {
    await checkAuthorization(queryClient, request);

    const authUser = await getAuthUser(queryClient, request);

    const canSeeSystemsDropdown = authUser?.canSeeSystemsDropdown ?? true;

    if (!canSeeSystemsDropdown) {
      return {};
    }

    const listSystemsResponse =
      await queryClient.ensureQueryData(listSystemsQuery);

    return { systems: listSystemsResponse };
  };
